import Typography from '@mui/material/Typography';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { getSnackTextColor } from '@/features/snacks/utils/getSnackTextColor';
import { theme } from '@/styles/theme/theme';

const regExpGroup = /\{(\w+)\}/g;

export const convertServerSideMessageToBoldContent = (
  message: string,
  payload: Record<string, string | string[]> | undefined,
) => {
  const resolvePlaceholderValue = (key: string, payload: Record<string, string | string[]> | undefined): string => {
    if (!payload || !payload[key]) return '';
    const value = payload[key];

    return Array.isArray(value) ? value.join(', ') : value;
  };

  const messageParts = message.split(regExpGroup);

  return (
    <Typography variant="body1" sx={{ color: getSnackTextColor(theme, SnackType.Info) }}>
      {messageParts.map((part, index) =>
        index % 2 === 1 ? (
          <Typography key={index} variant="body1Bold" component="span">
            {resolvePlaceholderValue(part, payload)}
          </Typography>
        ) : (
          part
        ),
      )}
    </Typography>
  );
};
